import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import { Loader, Dimmer, ItemContent } from 'semantic-ui-react';
import useTable from '../components/useTable';
import { TableBody, TableRow, TableCell, InputAdornment } from '@material-ui/core';
import axios from "axios";


const CatalogoAsientos = props => {

    let op = require('../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(sessionStorage.getItem('idefiscal'));

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({
        idalmacen: '',
        descripcion: '',
        responsable: '',
        ventas: false
    });
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CODIGO', textAlign: 'center' },
        { label: 'DESCRIPCION', textAlign: 'center' },
     
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (  props.tabla === 0 ? x.idasiento.includes(target.value) : ''
                            ||  props.tabla === 0 ? x.descripcion.toLowerCase().includes(target.value.toLowerCase()) : '') {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {
       
   
  
        let campos = 'idasiento,descripcion';
        let nomtab = 'asiento';
        let orden = 'idasiento';
    
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                     setRecords(response.data); 
                }         
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(()=>{
            setActivate(false); 
        })

    }


    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setValues({
            idalmacen: '',
            descripcion: '',
            responsable: '',
            ventas: false
        });
        setFilterFn({ fn: items => { return items; } });
    }


    const cancelar = () => {
        props.onHideCancelar();
        blanquear();

    }


    const seleccionarAlmacen = () => {
  
        props.onHideAceptaCatalogo(values.idasiento);

    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();

        setValues({
            idasiento: item.idasiento
           
        });
        btnAcepta.current.focus();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                 seleccionarRegistros(); 

            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <div className="fw-bold text-light"><h3>Seleccionar Almacen</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>Cargando...</Loader>
                </Dimmer>
                <div className="col-md-12" style={{ marginBottom: "10px" }}>
                    <div className="row">
                        <div className="input-group col-md-2 input-group-sm mb-3">
                            <input type='text'
                                onChange={handleSearch} className="form-control" />
                            <button className='btn btn-info' style={{ pointerEvents: 'none' }}><i className='fa fa-search'></i></button>
                        </div>
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <TableBody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <TableRow key={index} style={{ padding: "0", cursor: 'pointer', background: values.idasiento === item.idasiento ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <TableCell className='py-2 text-center'>{item.idasiento}</TableCell>
                                        <TableCell className='py-2 text-center'>{item.descripcion}</TableCell>
                                    </TableRow>

                                ))
                            }
                        </TableBody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" style={{ margin: "5px" }} onClick={seleccionarAlmacen}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoAsientos;


// WEBPACK FOOTER //
// ./src/catalogos/catalogoAsientos.js